import { Dispatch } from 'redux';
import Event from '../Event';

export interface EventToSideEffect {
    type: string[];
    fn: (event?: Event) => void;
}

// tslint:disable:typedef
export default (configuration: EventToSideEffect[]) => () => (next: Dispatch<Event>) => (event: Event): Event => {
    const existingMap: EventToSideEffect | undefined = configuration.find(
        (map: EventToSideEffect): boolean => {
            return map.type.indexOf(event.type) !== -1;
        }
    );
    if (existingMap) {
        existingMap.fn();
    }
    return next(event);
};



// WEBPACK FOOTER //
// ./src/application/core/middleware/eventToSideEffect.ts